module.exports = __webpack_public_path__ + "img/info.7df2728f.svg";